"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notifyForTranslations = exports.timezoneTranslations = exports.titleTranslations = exports.subCategoryTranslations = exports.tabTranslations = exports.sidebarTranslations = exports.preferenceErrorTranslations = exports.checkboxTranslations = void 0;
exports.checkboxTranslations = {
    web: 'notification_center_preferences-web',
    instantEmail: 'notification_center_preferences-instant_email',
    digestEmail: 'notification_center_preferences-digest_email',
    selectAll: 'notification_center_preferences-select_all',
};
exports.preferenceErrorTranslations = {
    upsertError: 'notification_center-upsert_preferences_error',
    loadError: 'notification_center_preferences-load_error',
    emptyResults: 'notification_center_preferences-empty_results',
};
exports.sidebarTranslations = {
    preferences: 'notification_center_preferences-preferences',
    settings: 'notification_center_preferences-settings',
};
exports.tabTranslations = {
    preTransport: 'notification_center_preferences-pre_transport',
    mainCarriage: 'notification_center_preferences-main_carriage',
    onCarriage: 'notification_center_preferences-on_carriage',
    other: 'notification_center_preferences-other',
};
exports.subCategoryTranslations = {
    booking: 'notification_center_preferences-pre_transport-booking',
    crd: 'notification_center_preferences-pre_transport-crd',
    rolledCargo: 'notification_center_preferences-pre_transport-rolled_cargo',
    customs: 'notification_center_preferences-on_carriage-customs',
    demdet: 'notification_center_preferences-on_carriage-demdet',
    miscellaneous: 'notification_center_preferences-other-miscellaneous',
    shipmentUpdates: 'notification_center_preferences-other-shipment_updates',
};
exports.titleTranslations = {
    title: 'notification_center_preferences-title',
    settingsDescription: 'notification_center_preferences-settings_description',
};
exports.timezoneTranslations = {
    title: 'notification_center-timezone-title',
    description: 'notification_center-timezone-description',
    inputLabel: 'notification_center-timezone-label',
};
exports.notifyForTranslations = {
    title: 'notification_center-notifyfor-title',
    description: 'notification_center-notifyfor-description',
    optionAll: 'notification_center-notifyfor-option_all',
    optionSubscribedOnly: 'notification_center-notifyfor-option_subscribed_only',
};
//# sourceMappingURL=translations.js.map